import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import TagsInput from 'react-tagsinput'

import {
  FormGroup,
  Label,
  Input,
  Button,
  Media,
  Col,
  Row,
  Container,
  Popover,
  PopoverContent
} from 'src/components/Common/reactstrap/lib';
import Breadcrumbs from 'src/components/Breadcrumbs/Breadcrumbs';
import {isAuthenticated} from '../../logic/authHelpers';
import Radio from 'src/components/Radio/Radio';
import Checkbox from 'src/components/Checkbox/Checkbox';
import InlineSVG from 'react-svg-inline';

import fbIcon from 'src/imgs/fb-icon.svg';
import okIcon from 'src/imgs/ok-icon.svg';
import vkIcon from 'src/imgs/vk-icon.svg';

import DayPicker, {DateUtils} from "react-day-picker";
import moment from 'moment';
import InputElement from 'react-input-mask';

import "moment/locale/ru";
import MomentLocaleUtils from 'react-day-picker/moment';

import styles from './User.scss';
import ModalChangePassword from './elements/ModalChangePassword';
import ModalCompany from './elements/ModalCompany';
import ModalAddress from './elements/ModalAddress';
import ModalEmails from './elements/ModalEmails';
import ModalDelete from './elements/ModalDelete';
import EditPhoneInput from './elements/EditPhoneInput';
import * as actions from './redux/userAction';
import ModalSocialNetworkDelete from './elements/ModalSocialNetworkDelete';

const currentYear = (new Date()).getFullYear();
const fromMonth = new Date(1910, 0, 1, 0, 0);
const toMonth = new Date(currentYear - 16, 11, 31, 23, 59);

// Component will receive date, locale and localeUtils props

function YearMonthForm({date, localeUtils, onChange}) {

  const months = moment.months();
  const years = [];
  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }

  const handleChange = function handleChange(e) {
    const {year, month} = e.target.form;
    onChange(new Date(year.value, month.value));
  };

  return (
    <form className="DayPicker-Caption">
      <select name="month" onChange={ handleChange } value={ date.getMonth() }>
        { months.map((month, i) =>
          <option key={ i } value={ i }>
            { month }
          </option>)
        }
      </select>
      <select name="year" onChange={ handleChange } value={ date.getFullYear() }>
        { years.map((year, i) =>
          <option key={ i } value={ year }>
            { year }
          </option>)
        }
      </select>
    </form>
  );
}


class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateValue: props.userData.birthday ? moment(props.userData.birthday).format('L') : '',
      selectedDay: props.userData.birthday ? new Date(props.userData.birthday) : null,
      popoverOpen: false,
      address: [],
      addressToDeleteId: null,
      addressToEdit: null,
      company: [],
      companyToDeleteId: null,
      companyToEdit: null,
      socialNetworkToDeleteId: null
    };

    this.toggle = this.toggle.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateUserData = this.updateUserData.bind(this);
    this.closeModal = this.closeModal.bind(this);


    this.confirmDeleteSocialNetwork = this.confirmDeleteSocialNetwork.bind(this);
    this.cancelDeleteSocialNetwork = this.cancelDeleteSocialNetwork.bind(this);
    this.handleChangeNotifyTime = this.handleChangeNotifyTime.bind(this);
  }

  componentWillReceiveProps(props) {
    this.setState({
      dateValue: props.userData.birthday ? moment(props.userData.birthday).format('L') : '',
      selectedDay: props.userData.birthday ? new Date(props.userData.birthday) : null,
    });
  }

  componentWillMount(){
    this.props.actions.fetchUserData();
    this.props.actions.getUserEmails();
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  handleDayClick(e, day) {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
      dateValue: moment(day).format('L'),
      selectedDay: moment(day).toDate(),
    }, function () {
      this.updateUserData(e, day);
    });
     // recall update because onChange has old state delay
  }

  handleInputChange(e) {
    const dateValue = e.target.value;
    const momentDay = moment(dateValue, 'L', true);
    if (momentDay.isValid()) {
      this.setState({
        selectedDay: momentDay.toDate(),
        dateValue,
      }, () => {
        this.daypicker.showMonth(this.state.selectedDay);
      });

    } else {
      this.setState({dateValue, selectedDay: null});
    }
  }

  updateUserData(e, day = false) {
    //do refactor - all data update in one method as change notify time

    const gender = e.gender || this.props.userData.gender,
      notifyBySms = typeof e.notifyBySms  != 'undefined' ? e.notifyBySms : this.props.userData.notifyBySms,
      notifyByEmail = typeof e.notifyByEmail  != 'undefined' ? e.notifyByEmail : this.props.userData.notifyByEmail;
    let birthday, {firstName, email} = this.props.userData;
    if (day) birthday = moment(day).format('YYYY-MM-DDThh:mm:ssZ');
    else  birthday = this.state.selectedDay ? moment(this.state.selectedDay).format('YYYY-MM-DDThh:mm:ssZ') : null;

    this.props.actions.updateUserData({firstName, birthday, email, gender, notifyByEmail, notifyBySms} );
  }

  closeModal() {
    this.setState({
      companyToEdit: null,
      companyToDeleteId: null,
      addressToEdit: null,
      addressToDeleteId: null,
      emailToEdit: null,
      emailToDeleteId: null,
    });
  }

  confirmDeleteSocialNetwork(id) {
    this.setState({
      socialNetworkToDeleteId: id
    });
  }

  cancelDeleteSocialNetwork() {
    this.setState({
      socialNetworkToDeleteId: null
    });
  }

  changeGender = (gender) => {
    if (gender != this.props.userData.gender) {
      this.props.actions.changeUserGender(gender);
      this.updateUserData({gender: gender});
    }
  };
  changeNotify = (notify) => {

    this.updateUserData(notify);
    this.props.actions.changeUserNotify(notify);
  };
  parseTime(data){
    let time = _.map(data, (value) => {
      return value.scheduleTime.slice(0, 2);
    }, []);
    return (time[0]) ? time : [];
  }
  handleChangeNotifyTime(NotifyTime) {
    //this.setState({NotifyTime: _.uniq(NotifyTime)}); notifyScheduleTime

    let time = _.map(_.uniq(NotifyTime), (value) => {
      return {
        notifyScheduleId: 0,
        scheduleTime: value + ':00:00'
      }
    }, []);
    this.props.actions.updateNotifyTime({notifyScheduleTime: time});
  }
  renderLegals(id) {
    return this.props.userData.legals.map((legal) => {
      return isNaN(id) ?
        (
          <Row className="m-t-0_5" key={legal.legalId}>
            <Col sm={12} className="m-b-0_5">
              <b>{legal.type.legalTypeName} {legal.name}</b>
            </Col>
            <Col sm={4}>
              <b>ИНН</b> {legal.inn}
            </Col>
            <Col sm={6}>
              <b>БИК</b> {legal.bik}
            </Col>
            { +legal.type.legalTypeId === 1
              ? <Col>
                </Col>
              : <Col sm={4}>
                  <b>КПП</b> {legal.kpp}
                </Col>
            }
            <Col sm={7}>
              <b>Р/С</b> {legal.paymentAccount}
            </Col>
            <Col sm={12}>
              <b>Юр. адрес</b> {legal.legalAddress}
            </Col>
            <Col sm={12}>
              <Button color="link" onClick={() => this.setState({
                companyToEdit: legal
              })}>Редактировать</Button>
              <Button color="link" onClick={() => this.setState({
                companyToDeleteId: legal.legalId
              })}>Удалить</Button>
            </Col>
          </Row>
        ) : (
          <div className="mt-1" key={legal.legalId}>
            <Radio
              disabled={false}
              labelText={`От лица компании ${legal.name}`}
              name={legal.legalId}
              onChange={() => this.props.actions.setPaymentsDefault(legal.legalId)}
              checked={id==legal.legalId}
            />
          </div>
        );
    });
  }

  renderAddresses() {
    return this.props.userData.deliveryAddresses.map((address) => {
      return (
        <Row className="m-t-1" key={address.deliveryAddressId}>
          <Col sm={12}>
            <b>г.{address.city} ул.{address.street} д.{address.house} кв.{address.office}</b>
          </Col>
          <Col sm={12}>
            <Button color="link" onClick={() => this.setState({
              addressToEdit: address
            })}>Редактировать</Button>
            <Button color="link" onClick={() => this.setState({
              addressToDeleteId: address.deliveryAddressId
            })}>Удалить</Button>
          </Col>
        </Row>
      );
    });
  }
  renderEmails() {
    if (!this.props.userData.emails) return <Row></Row>;
    return this.props.userData.emails.map((emails) => {
      return (
        <Row className='mt-1' key={emails.email}>
          <Col sm={12} className="mb-3">
            {emails.email}
          </Col>
          <Col sm={4}>
            <Checkbox
              text={`Для документов`}
              name="forDocs"
              checked={emails.forDocuments}
              onChange={() => this.props.actions.addOrUpdateEmail([{
                ...emails, forDocuments: !emails.forDocuments
              }])}
            /></Col>
          <Col sm={6}>
            <Checkbox
              text={`Уведомления по заказам`}
              name="forOrders"
              checked={emails.forOrders}
              onChange={() => this.props.actions.addOrUpdateEmail([{
                ...emails, forOrders: !emails.forOrders
              }])}
            />
          </Col>
          <Col sm={12}>
            <Button color="link" onClick={() =>  this.setState({
              emailToEdit: emails
            })}>Редактировать</Button>
            <Button color="link" onClick={() =>  this.setState({
              emailToDeleteId: emails.userEmailId
            })}>Удалить</Button>
          </Col>
        </Row>
      );
    });
  }

  getSocialNetworkIcon(networkTypeName) {
    switch (networkTypeName) {
      case 1:
        return vkIcon;
      case 2:
        return okIcon;
      case 3:
        return fbIcon;
      default:
        return '';
    }
  }

  renderSocialNetworks() {
    let socialNetworks = this.props.userData.socialNetworks || [];
    return socialNetworks.map((socNetwork) => {
      return (
        <div>
          <Media className="mt-1">
            <Media left middle>
              <InlineSVG
                svg={this.getSocialNetworkIcon(socNetwork.type)}/>
            </Media>
            <Media body>
              <Media heading>
                <b>{socNetwork.socialNetworkUserName}</b>
              </Media>
            </Media>
          </Media>
          <Button color="link"
                  onClick={() => this.confirmDeleteSocialNetwork(socNetwork.socialNetworkDataId)}>Удалить</Button>
        </div>
      );
    });
  }

  render() {
    let userData = this.props.userData,
      paymentDefault = this.props.userData.paymentDefault,
      deleteSocialNetworkVisible = this.state.socialNetworkToDeleteId ? true : false;

    if (!isAuthenticated()) {
      return (
        <Container>Нет доступа</Container>
      );
    }
console.log(this);
    return (
      <Container>
        <Breadcrumbs
          routes={this.props.routes}/>
        <h2>Настройки</h2>
        <Row className={styles.user_custom_form}>
          <Col sm={6}>
            {userData.phone
              ? <div>
                <ModalChangePassword onChangePassword={this.props.actions.onChangePassword}/>
                <div className="m-b-2"></div>
              </div>
              : null}
            <FormGroup row>
              <Label for="name" sm={3}>ФИО</Label>
              <Col sm={9}>
                <Input name="name"
                       value={userData.firstName || ''}
                       onChange={(e) => this.props.actions.changeUserFullName(e.target.value)}
                       onBlur={this.updateUserData}/>
              </Col>
              <Label for="phone" sm={3}>Телефон</Label>
              <Col sm={9}>
                <EditPhoneInput value={userData.phone || ''}/>
              </Col>
              <Label for="date" sm={3}>Дата рождения</Label>
              <Col sm={{size: 3, pull: 6, offset: 6}}>
                <InputElement
                  className="form-control"
                  mask="99.99.9999"
                  type="text"
                  ref={ (el) => {
                    this.input = el;
                  } }
                  value={ this.state.dateValue }
                  onChange={ this.handleInputChange }
                  onBlur={this.updateUserData}
                  id="Popover1" onClick={this.toggle}
                />
                <Popover className="popover-datepicker" placement="bottom left" isOpen={this.state.popoverOpen}
                         target="Popover1" toggle={this.toggle}>

                  <PopoverContent>
                    <DayPicker
                      localeUtils={ MomentLocaleUtils } locale="ru"
                      ref={ (el) => {
                        this.daypicker = el;
                      } }
                      initialMonth={ this.state.selectedDay || undefined }
                      onDayClick={ this.handleDayClick }
                      selectedDays={ day => DateUtils.isSameDay(this.state.selectedDay, day) }
                      fromMonth={ fromMonth }
                      toMonth={ toMonth }
                      captionElement={
                        <YearMonthForm onChange={ selectedDay => this.setState({selectedDay}) }/>
                      }
                    />
                  </PopoverContent>
                </Popover>


              </Col>
              <Label for="date" sm={2} className={styles.label_checkbox}>Пол</Label>
              <Col sm={3}>
                <Radio
                  disabled={false}
                  labelText="мужской"
                  name="Gender"
                  onChange={() => this.changeGender(1)}
                  checked={userData.gender === 1 }
                />
              </Col>
              <Col sm={3}>
                <Radio
                  disabled={false}
                  labelText="женский"
                  name="Gender"
                  onChange={() => this.changeGender(2)}
                  checked={userData.gender === 2}
                />
              </Col>
            </FormGroup>
            <div className="m-b-2"></div>
            <h3>Компании</h3>
            {this.renderLegals('list')}
            <Button onClick={() =>  this.setState({
              companyToEdit: {}
            })}>Добавить компанию</Button>
            {this.state.companyToEdit && <ModalCompany
              visible={true}
              company={this.state.companyToEdit}
              close={this.closeModal}
              legalTypes={this.props.userData.LegalTypes}
              addOrUpdateLegals={this.props.actions.addOrUpdateLegals}/>}
            {this.state.companyToDeleteId && <ModalDelete
              userId={this.state.userId}
              className="modal-delete"
              visible={true}
              close={this.closeModal}
              id={this.state.companyToDeleteId}
              name="legalId"
              text="Удалить компанию?"
              submitDelete={this.props.actions.removeUserLegals}/>}

            <h3>Оплата заказов</h3>
            <Radio
              disabled={false}
              labelText="От физического лица"
              name="individual"
              onChange={() => this.props.actions.setPaymentsDefault(0)}
              checked={paymentDefault == 0}
            />
            {this.renderLegals(paymentDefault)}
            <h3>Адреса доставки</h3>
            {this.renderAddresses()}
            <Button onClick={() => this.setState({
              addressToEdit: {}
            })}>Добавить адрес</Button>
            { this.state.addressToEdit && <ModalAddress
              visible={true}
              address={this.state.addressToEdit}
              close={this.closeModal}
              addOrUpdateAddresses={this.props.actions.addOrUpdateAddresses}/>}
            { this.state.addressToDeleteId && <ModalDelete
              className="modal-delete"
              visible={true}
              close={this.closeModal}
              id={this.state.addressToDeleteId}
              name="deliveryAddressId"
              text="Удалить адрес?"
              submitDelete={this.props.actions.removeUserAddresses}/>}

            <h3>Эл. почта</h3>
            {this.renderEmails()}
            <Button onClick={() =>  this.setState({
              emailToEdit: {
                email:null,
                forDocuments:false,
                forOrders:false
              }
            })}>Добавить адрес</Button>
            {this.state.emailToEdit && <ModalEmails
              visible={true}
              email={this.state.emailToEdit}
              close={this.closeModal}
              updateEmail={this.props.actions.addOrUpdateEmail}/>}
            {this.state.emailToDeleteId && <ModalDelete
              className="modal-delete"
              visible={true}
              close={this.closeModal}
              id={this.state.emailToDeleteId}
              name="userEmailId"
              text="Удалить email?"
              submitDelete={this.props.actions.removeUserEmail}/>}
            <h3>Связанные аккаунты в соц.сетях</h3>
            {this.renderSocialNetworks()}
            <ModalSocialNetworkDelete
              className="modal-delete"
              visible={deleteSocialNetworkVisible}
              close={this.cancelDeleteSocialNetwork}
              socialNetworkToDeleteId={this.state.socialNetworkToDeleteId}
              deleteSocialNetwork={this.props.actions.deleteSocialNetwork}/>
            <h3>Подписка на уведомления</h3>
            <Row>
              <Col sm={12} className="m-b-0_5">
                <Checkbox
                  text={`получать уведомления по SMS`}
                  name="notifyBySms"
                  checked={userData.notifyBySms}
                  onChange={() => this.changeNotify({notifyBySms: !this.props.userData.notifyBySms})}
                />
              </Col>
              <Col sm="12">
                <Checkbox
                  text={`получать уведомления по эл.почте`}
                  name="notifyByEmail"
                  checked={userData.notifyByEmail}
                  onChange={() => this.changeNotify({notifyByEmail: !this.props.userData.notifyByEmail})}
                />
              </Col>
              <Col sm="6" className="mt-2 pr-2">
                <TagsInput
                  name="NotifyTime"
                  value={this.parseTime(this.props.userData.notifyScheduleTime)}
                  addKeys={[32, 188]}
                  onChange={this.handleChangeNotifyTime}
                  addOnBlur={true}
                  onlyUnique={true}
                  disabled={!(this.props.userData.notifyByEmail || this.props.userData.notifyBySms)}
                  maxTags={10}
                  validationRegex={/^([01]?[0-9]|2[0-4])$/}
                  onValidationReject={(er) => console.log(er)}
                  inputProps={{placeholder: 'Время получения уведомлений'}}
                />
              </Col>
            </Row>
          </Col>
        </Row>

      </Container>
    );
  }
}
User.contextTypes = {
  userData: React.PropTypes.object
};
User.routeTitle = "Настройки";
export default connect(
  (state) => ({
    userData: state.userReducer
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
  })
)(User);



/** WEBPACK FOOTER **
 ** ./src/components/User/User.jsx
 **/